module.exports = __webpack_public_path__ + "dist/media/ec_comp_media_container.f084e886.svg";